import { attr, fk } from 'redux-orm';
import { BaseModel } from './base';
import { ThreadStatus, LinkedInSentMessageError } from '../const/enum';

export interface IOutboxMessage {
    threadId: string;
    message: string;
    timestamp: string;
    orgMemberId: string;
    contactId: string;
    dateCreated: string;
    status: ThreadStatus;
    error: LinkedInSentMessageError;
    id: string;
    name: string;
    isContactDeleted: boolean;
}

export class OutboxMessage extends BaseModel<typeof OutboxMessage, IOutboxMessage> {
    static modelName = 'OutboxMessage';
    static fields = {
        id: attr(),
        threadId: attr(),
        message: attr(),
        contactId: attr(),
        dateCreated: attr(),
        timestamp: attr(),
        orgMemberId: fk({ to: 'OrganizationMember', as: 'organizationMember' }),
        status: attr(),
        error: attr(),
        name: attr(),
        isContactDeleted: attr(),
    };
}
